import { useMutation } from '@tanstack/react-query';
import type { PromotionPolicyImportProductsResult } from '@sleed/bizcommerce-api';
import { promotionPoliciesApi } from '~/lib/api/client';

/**
 * Bulk-resolves a pasted and/or uploaded (.xlsx/.csv/.txt) list of product codes/barcodes to product
 * ids via the PromotionPolicies/ImportProducts endpoint. Resolve-only: the caller merges the returned
 * `matchedProducts` into the editor's `productIds` field; persistence flows through the normal Save.
 */
export function usePromotionProductImport() {
	return useMutation<PromotionPolicyImportProductsResult, unknown, { codes?: string; file?: File }>({
		mutationFn: async ({ codes, file }) => (await promotionPoliciesApi.importProducts(codes, file)).data
	});
}
